import styled from '@emotion/styled';

import { head } from 'lodash';

import COLOR from '../../../../../../shared/constant/colorset';

import SingleDeal from './SingleDeal';
import MultiDeal from './multi-deal/MultiDeal';
import OptionContent from './option-content/OptionContent';
import CalendarContent from './calendar-content/CalendarContent';
import DeliveryDelayNotice from './DeliveryDelayNotice';

import useDeliveryDelayNotice from '../../../../hooks/useDeliveryDelayNotice';
import { useAppSelector } from '../../../../../../shared/store';

const Container = styled.div`
  border-bottom: 1px solid ${COLOR.bg};
`;

export default function ProductOption() {
  const productNo = useAppSelector(({ productDetail }) => productDetail.no);
  const isSoldOut = useAppSelector(({ productDetail }) => productDetail.isSoldOut);
  const isPurchaseStatus = useAppSelector(({ productDetail }) => productDetail.isPurchaseStatus);
  const dealProducts = useAppSelector(({ productDetail }) => productDetail.dealProducts);
  const contentType = useAppSelector(({ productDetail }) => productDetail.contentType);
  const groupProduct = useAppSelector(({ productDetail }) => productDetail.groupProduct);

  const currentDealProduct = head(dealProducts);

  const { deliveryDelayNotice } = useDeliveryDelayNotice();

  if (!currentDealProduct) {
    return null;
  }

  return (
    <Container>
      {contentType === 'SINGLE' && (
        <SingleDeal dealProduct={currentDealProduct} isPurchaseStatus={isPurchaseStatus} isSoldOut={isSoldOut} />
      )}
      {contentType === 'MULTI' && <MultiDeal dealProducts={dealProducts} />}
      {contentType === 'OPTION' && (
        <OptionContent
          productNo={productNo}
          groupKeys={groupProduct.groupKeys}
          groupMembers={groupProduct.groupMembers}
          dealProduct={currentDealProduct}
        />
      )}
      {contentType === 'CALENDAR' && (
        <CalendarContent
          productNo={productNo}
          groupKeys={groupProduct.groupKeys}
          groupMembers={groupProduct.groupMembers}
          dealProduct={currentDealProduct}
        />
      )}
      {!!deliveryDelayNotice ? <DeliveryDelayNotice description={deliveryDelayNotice} /> : null}
    </Container>
  );
}
